import client from './client';

export interface AkimatDoc {
  id: number;
  title: string;
  type?: string;
  date?: string;
  url?: string;
  file_url?: string;
  views?: number;
}

export interface DocType {
  type: string;
  count: number;
}

export interface DocsResponse {
  total: number;
  page: number;
  size: number;
  items: AkimatDoc[];
}

const BASE = '/api/admin/akimat';

export const akimatApi = {
  getDirectory: () => client.get(`${BASE}/directory`).then((r) => r.data),
  putDirectory: (data: any) =>
    client.put(`${BASE}/directory`, data).then((r) => r.data),

  getDocuments: (params: { type?: string; page?: number; size?: number }) =>
    client.get<DocsResponse>(`${BASE}/documents`, { params }).then((r) => r.data),
  getDocTypes: () =>
    client.get(`${BASE}/documents/types`).then((r) => r.data.types as DocType[]),
  syncDocuments: () =>
    client.post(`${BASE}/documents/sync`).then((r) => r.data),
};
